import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Plus_Jakarta_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\",\"800\"],\"variable\":\"--font-plus-jakarta\",\"display\":\"swap\"}],\"variableName\":\"plusJakarta\"}");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/opt/build/repo/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/styles/tailwind.css");
